(() => {
  if (window.dpSocialCountersLoaded) return;
  window.dpSocialCountersLoaded = true;
  const instances = new Map();
  function initialize(root) {
    if (instances.has(root)) return;
    const endpoint = root.dataset.endpoint;
    if (!endpoint) return;
    let url;
    try {
      url = new URL(endpoint, window.location.origin);
      if (url.protocol !== 'https:' || url.username || url.password) return;
      if (url.origin === window.location.origin && !url.pathname.startsWith('/apps/')) return;
    } catch { return; }
    let timer;
    let stopped = false;
    const cards = [...root.querySelectorAll('[data-platform]')];
    const lastKnown = new Map();
    const locale = root.dataset.locale || 'fr';
    const formatter = new Intl.NumberFormat(locale);
    const dateFormatter = new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short', timeZone: 'America/Toronto' });
    function render(card, entry, failed = false) {
      const count = card.querySelector('[data-count]');
      const group = card.querySelector('[data-count-group]');
      const empty = card.querySelector('[data-empty]');
      const label = card.querySelector('[data-count-date]');
      if (!entry) {
        group.hidden = true;
        empty.hidden = false;
        return;
      }
      const prefix = card.querySelector('[data-count-prefix]');
      prefix.textContent = root.dataset.approximateLabel;
      prefix.hidden = !entry.approximate;
      count.textContent = formatter.format(entry.count);
      const stale = failed || Date.now() - entry.timestamp > 48 * 60 * 60 * 1000;
      label.textContent = stale ? root.dataset.staleLabel : root.dataset.updatedLabel;
      label.title = `${dateFormatter.format(new Date(entry.timestamp))} (Toronto)`;
      label.dataset.stale = String(stale);
      group.hidden = false;
      empty.hidden = true;
    }
    async function refresh() {
      if (stopped || !root.isConnected) return;
      if (document.hidden) { timer = setTimeout(refresh, 300000); return; }
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url.href, { mode: 'cors', credentials: 'omit', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Unavailable');
        const data = await response.json();
        for (const card of cards) {
          const key = card.dataset.platform;
          const record = data?.[key];
          const timestamp = typeof record?.updated_at === 'string' ? Date.parse(record.updated_at) : NaN;
          const valid = Number.isSafeInteger(record?.count) && record.count >= 0 && Number.isFinite(timestamp) && timestamp > 0 && timestamp <= Date.now() && (record.approximate === undefined || typeof record.approximate === 'boolean');
          if (valid) {
            const entry = { count: record.count, timestamp, approximate: record.approximate === true };
            lastKnown.set(key, entry);
            render(card, entry);
          } else render(card, lastKnown.get(key), true);
        }
      } catch {
        cards.forEach(card => render(card, lastKnown.get(card.dataset.platform), true));
      } finally {
        clearTimeout(timeout);
        if (!stopped && root.isConnected) timer = setTimeout(refresh, 300000);
      }
    }
    instances.set(root, () => { stopped = true; clearTimeout(timer); });
    refresh();
  }
  function scan(scope) { scope.querySelectorAll('[data-social-counters]').forEach(initialize); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((stop, root) => {
      if (event.target.contains(root)) { stop(); instances.delete(root); }
    });
  });
})();
